// app/products/ProductsClient.tsx
"use client";

import React from 'react';
import Image from 'next/image';
import ResponsiveLink from '../general/ResponsiveLink';

export default function ProductsClient({ products }: { products: any[] }) {

  return (
    <div className="w-full px-4 sm:px-6 py-18">
      <div className="mx-auto max-w-6xl">
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <ResponsiveLink
              product={product}
              key={product._id}
              href={product.redirectUrl}
              className="bg-[#16120E] rounded-xl shadow-lg overflow-hidden hover:shadow-xl hover:shadow-white/30 transition-all duration-300 flex flex-col h-full"
            >
              {/* Rest of your product card JSX remains the same */}
              <div className="relative aspect-[4/3]">
                {product.imagePath ? (
                  <Image
                    src={product.imagePath}
                    alt={product.name}
                    fill
                    className="object-cover"
                    sizes={`(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw`}
                    priority={index < 4}
                  />
                ) : (
                  <Image
                    src="/uploads/missing.png"
                    alt={product.name}
                    fill
                    className="object-cover"
                    sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
                  />
                )}
              </div>
              
              <div className="p-5 flex-grow flex flex-col space-y-3">
                <div className="flex justify-between items-start">
                  <h2 className="text-lg font-semibold text-white line-clamp-2 leading-tight">
                    {product.name}
                  </h2>
                  <span className="bg-[#272A2C] text-white text-xs font-medium px-2 py-1 rounded ml-2 flex-shrink-0">
                    #{index + 1}
                  </span>
                </div>
                
                <p className="text-sm line-clamp-4 leading-relaxed text-white">
                  {product.description}
                </p>
                
                <div className="mt-auto pt-3">
                  <div className="flex justify-between items-center">
                    <p className="text-lg font-bold text-[#8FBC8F]">
                      ${product.price?.toFixed(2)}
                    </p>
                    <p className="text-xs bg-[#272A2C] text-white px-2 py-1 rounded">
                      {product.clicks} views
                    </p>
                  </div>
                </div>
              </div>
            </ResponsiveLink>
          ))}
        </div>
      </div>
    </div>
  );
}